__turbopack_context__.v({
  "container": "ContactForm-module__f_V9Ma__container",
  "container__bottom": "ContactForm-module__f_V9Ma__container__bottom",
  "container__double": "ContactForm-module__f_V9Ma__container__double",
  "phone_container": "ContactForm-module__f_V9Ma__phone_container",
  "phone_container__error_message": "ContactForm-module__f_V9Ma__phone_container__error_message",
});
